import { Routes, Route } from 'react-router-dom';
import ErrorPage from '../components/ErrorPage';
import Home from '../pages/homepage/Home';
import NoPageAccess from '../pages/NoPageAccess';
import UserLogin from '../pages/auth/UserLogin';
import UserReg from '../pages/auth/UserReg';
import EmailRegister from '../pages/auth/EmailRegister';
import CreateBizProfile from '../pages/auth/CreateBizProfile';
import CreateStore from '../pages/auth/CreateStore';
import Dashboard from '../pages/user/Dashboard';
import Inventory from '../pages/user/Inventory';
import Item from '../pages/user/Item';
import Expenses from '../pages/user/Expenses';
import Customers from '../pages/user/Customers';
import Supplier from '../pages/user/Suppliers';
import DebtManagement from '../pages/user/DebtManagement';
import SalesPage from '../pages/user/SalesPage';
import Invoice from '../pages/user/Invoice';
import Settings from '../pages/user/Settings';
import Report from '../pages/user/Report';
import BusinessReport from '../components/user/report/business/BusinessReport';
import StoreReport from '../components/user/report/store/StoreReport';
import AllStoreReport from '../components/user/report/AllStoreReport';
import Billing from '../pages/user/Billing';
import Packages from '../pages/user/Packages';
import InvoiceData from '../components/user/invoice/InvoiceData';
import Employees from '../pages/user/Employees';
import Payroll from '../pages/user/Payroll';
import EmployeesPage from '../pages/user/EmployeesPage';
import EmployeeDetails from '../components/user/employees/EmployeeDetails';
import SetProfile from '../pages/auth/SetProfile';
import BusinessBanking from '../pages/user/BusinessBanking';
import MakePayment from '../components/user/packages/MakePayment';
import Waybill from '../pages/user/Waybill';
import PrintWaybill from '../components/user/waybill/PrintWaybill';
import PrintInvoice from '../components/user/invoice/PrintInvoice';
import NoUserAccess from '../pages/NoUserAccess';
import RegisterDone from '../pages/auth/RegisterDone';
import Notifications from '../pages/user/Notifications';


const Router = () => {
    return (
        <Routes>

            {/* Landing */}
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<UserLogin />} />
            <Route path="/set-profile" element={<SetProfile />} />
            <Route path="/register" element={<EmailRegister />} />
            <Route path="/register-complete" element={<UserReg />} />
            <Route path="register-success" element={<RegisterDone />} />

            <Route path="/create-business" element={<CreateBizProfile />} />
            <Route path="/create-store" element={<CreateStore />} />
            {/* Auth */}

            {/* Dashboard */}
            <Route path='user'>
                <Route index element={<Dashboard />} />
                <Route exact path="dashboard" element={<Dashboard />} />

                <Route exact path="expenses" element={<Expenses />} />

                <Route exact path="customers" element={<Customers />} />

                <Route exact path="suppliers" element={<Supplier />} />

                <Route exact path="debt-management" element={<DebtManagement />} />

                <Route path='employees'>
                    <Route index element={<Employees />} />

                    <Route exact path="staff" element={<Employees />} />

                    <Route exact path=":id" element={<EmployeeDetails />} />

                    <Route exact path="payroll" element={<Payroll />} />

                    <Route exact path="home" element={<EmployeesPage />} />

                </Route>
                <Route path='business-banking'>
                    <Route index element={<BusinessBanking />} />
                </Route>
                <Route path='reports'>
                    <Route index element={<Report />} />

                    <Route exact path="business" element={<BusinessReport />} />

                    <Route path='store'>
                        <Route index element={<AllStoreReport />} />
                        <Route exact path=":id" element={<StoreReport />} />
                    </Route>
                </Route>

                <Route path='waybill'>
                    <Route index element={<Waybill />} />

                    <Route exact path=":id" element={<PrintWaybill />} />
                </Route>
                <Route path='inventory'>
                    <Route index element={<Inventory />} />

                    <Route exact path="item" element={<Item />} />
                </Route>

                <Route path='sales'>
                    <Route index element={<SalesPage />} />

                    <Route path='invoice'>
                        <Route index element={<Invoice />} />

                        <Route exact path=":id" element={<InvoiceData />} />
                    </Route>
                </Route>

                <Route exact path="invoice/:id" element={<PrintInvoice />} />

                <Route path='notifications'>
                    <Route index element={<Notifications />} />
                </Route>


                <Route path='settings'>
                    <Route index element={<Settings />} />

                    <Route exact path="billing" element={<Billing />} />

                    <Route exact path="noAccess" element={<NoUserAccess />} />

                    <Route path='packages'>
                        <Route index element={<Packages />} />

                        <Route exact path="pay/:id" element={<MakePayment />} />
                    </Route>
                </Route>
            </Route>


            {/* Error */}
            <Route path="noAccess" element={<NoPageAccess />} />

            <Route path="*" element={<ErrorPage />} />

        </Routes>
    );
};

export default Router;